import React from "react";
import Img1 from "../../asset/FAQ/1.jpeg";
import Img2 from "../../asset/FAQ/2.jpeg";
import Img3_1 from "../../asset/FAQ/3.1.jpeg";
import Img3_2 from "../../asset/FAQ/3.2.jpeg";
import Img4 from "../../asset/FAQ/4.jpeg";
import Img5 from "../../asset/FAQ/5.jpeg";
import Img6 from "../../asset/FAQ/6.jpeg";
import Img7 from "../../asset/FAQ/7.jpeg";
import Img8_1 from "../../asset/FAQ/8.1.jpeg";
import Img8_2 from "../../asset/FAQ/8.2.jpeg";
import Img9 from "../../asset/FAQ/9.png";
import style from "./Style.module.css";

const IncomeShare = () => {
  return (
    <div>
      <p>
        เนื่องจากทาง moresheet ต้องบริการลูกค้าทั้งผู้ซื้อและผู้ขายให้ดีที่สุด
        ทางเราจึงต้องมีค่าใช้จ่ายในการพัฒนาระบบอยู่เสมอ
        รวมถึงการโปรโมทชีทซึ่งช่วยให้ทางผู้ขายมีรายได้และประหยัดเวลา
        ดังนั้นทางผู้ขายจะมีรายได้ 60% ของยอดขายทั้งหมด
        “เป็นประจำอย่างต่อเนื่องทุกๆเดือน” โดยมีการหักภาษี ณ ที่จ่าย
        (e-Withholding Tax) อัตรา 3% จากยอดขาย
      </p>
      <br />
      <p>
        *** ผู้รับเงิน (ผู้ถูกหักภาษี) ที่ถูกหักภาษี ณ ที่จ่ายผ่านระบบ
        E-Withholding Tax ในระหว่างวันที่ 1 มกราคม พ.ศ. 2566 ถึงวันที่ 31
        ธันวาคม พ.ศ. 2568 ได้รับการลดอัตราภาษีหัก ณ ที่จ่ายจาก 3% เป็น 1%
        จากมาตรการทางภาษีของกรมสรรพากร
      </p>

      <br />
      <p>
        *** ผู้รับเงิน (ผู้ถูกหักภาษี) ที่ถูกหักภาษี ณ ที่จ่ายผ่านระบบ
        E-Withholding Tax ตั้งแต่วันที่ 1 มกราคม พ.ศ. 2569 - 31 ธันวาคม พ.ศ.
        2570 ได้รับการลดอัตราภาษีหัก ณ ที่จ่ายจาก 3% เป็น 1%
        จากมาตรการทางภาษีของกรมสรรพากร
      </p>
      <br />
      <b>ขั้นตอนการเข้าระบบดาวน์โหลด e-Withholding Tax</b>

      <p>
        <b>1.</b> เข้าสู่เว็บไซต์ E-withholding tax :{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://epay.rd.go.th/wps/portal/RD/Home"
          style={{ color: "#0000EE" }}
        >
          https://epay.rd.go.th/wps/portal/RD/Home/
        </a>{" "}
        จะแสดงข้อมูลดังภาพด้านล่าง
      </p>
      <img src={Img1} className={style.imgFaq} alt="1" />
      <p>
        <b>2.</b> เลือกเมนู “เข้าสู่ระบบ e-Filing” Login
        ด้วยรหัสผู้ใช้งานและรหัสผ่านในระบบ e-Filing โดยระบุข้อมูล ดังนี้ <br />
        <div style={{ marginLeft: "20px" }}>
          2.1 รหัสผู้ใช้งาน : เลขประจำตัวผู้เสียภาษีอากรหรือเลขประจำตัวประชาชน
          13 หลัก
          <br />
          2.2 รหัสผ่าน
          <br />
          2.3 เลขด้านหลังบัตรประจำตัวประชาชน
        </div>
      </p>
      <img src={Img2} alt="2" className={style.imgFaq} />

      <p>
        <b>3.</b> ระบบแสดงข้อมูลเบื้องต้นจากระบบ e-Filing
        เพื่อให้ผู้ใช้งานตรวจสอบความถูกต้องของข้อมูล ดำเนินการให้ครบ 4
        ขั้นตอนนี้ เมื่อกรอกข้อมูลครบถึงขั้นตอนที่ 4 จะแสดงข้อมูลดังภาพ
      </p>
      <img src={Img3_1} alt="3_1" className={style.imgFaq} />
      <br />
      <img src={Img3_2} alt="3_2" className={style.imgFaq} />

      <p>
        <b>4.</b> กลับหน้าหลัก และให้ทำการเข้าสู่ระบบอีกครั้ง
      </p>
      <img src={Img4} alt="4" className={style.imgFaq} />

      <p>
        <b>5.</b> กลับหน้าหลัก และให้ทำการเข้าสู่ระบบอีกครั้ง
      </p>

      <img src={Img5} alt="5" className={style.imgFaq} />

      <p>
        <b>6.</b> เลือก "บริการคัดค้นข้อมูลภาษีและการใช้จ่าย" เลือก
        "เพิ่มคำขอคัดค้นข้อมูล"
      </p>
      <img src={Img6} alt="6" className={style.imgFaq} />
      <p>
        <b>7.</b> ระบบแสดงหน้าจอ “คำขอคัดค้นข้อมูลภาษีและการใช้จ่าย” เลือก
        ประเภทเป็น “ข้อมูลการถูกหักภาษีเงินได้หัก ณ ที่จ่าย จากระบบ
        e-Withholding Tax”
      </p>
      <img src={Img7} alt="7" className={style.imgFaq} />
      <p>
        <b>8.</b> เลือก เดือน/ปีภาษี เริ่มต้น และสิ้นสุด เลือกได้ไม่เกิน 12
        เดือน เลือกเลขที่สาขามูลค่าเพิ่ม กรณีไม่ระบุสาขาให้เลือกเป็นทั้งหมด
        และกดปุ่ม "ส่งคำขอ" ระบบประมวลผลคัดค้นข้อมูลการรับ-จ่ายเงิน จากระบบ
        e-Withholding Tax สำเร็จ โดยใช้เวลาทำการประมวลผลประมาณ 3 ชั่วโมง
      </p>
      <img src={Img8_1} alt="8" className={style.imgFaq} />
      <br />
      <img src={Img8_2} alt="8" className={style.imgFaq} />
      <p>
        <b>9.</b> ระบบจะแสดงปุ่มดาวน์โหลดข้อมูล
        ด้านหลังรายที่คัดค้นสำเร็จเท่านั้น กดปุ่ม “ดาวน์โหลด”
        ระบบจะดาวน์โหลดข้อมูลเป็นไฟล์ PDF โดยการเปิดไฟล์จะต้องระบุรหัสผ่าน
        ดังนี้ รหัสผ่านสำหรับเปิดไฟล์ คือ เลข 8
        หลักท้ายของเลขประจำตัวผู้เสียภาษีอากร
      </p>
      <img src={Img9} alt="9" className={style.imgFaq} />
    </div>
  );
};

export default IncomeShare;
